import SplitScreenContent from "../../components/SplitScreenContent";

export const tuevGutachtenEintragungen = {
  title: "TÜV-Gutachten & Eintragungen für Porsche",
  titleImageUrl: "porsche-engine.jpg",
  meta: {
    title:
      "TÜV-Eintragungen & Gutachten für Porsche – §19(2)/§21, Leistungssteigerung, Umbauten | WTM Sportwagen",
    description:
      "WTM Sportwagen begleitet Ihre Porsche-Umbauten bis zur erfolgreichen TÜV-Abnahme: §19(2)/§21-Einzelabnahme, Leistungssteigerung & Motorumbau, Bremsen/Fahrwerk/Räder, Sonderanfertigungen, H-Gutachten & Import. End-to-end inkl. Dokumentation, Messungen & Terminmanagement.",
  },
  content: [
    {
      type: "hero_image",
      backgroundImage:
        "https://res.cloudinary.com/donwh3eei/image/upload/v1756323443/gallery/frank_kayser/M10_7649_qll9te",
      headline: "Legal. Sauber. Eingetragen.",
      description:
        "Ob Leistungssteigerung, Fahrwerk, Bremsen, Räder oder Sonderteile: Wir bereiten Ihren Porsche technisch und formal so vor, dass die Eintragung klappt – von der ersten Idee bis zur bestandenen Abnahme.",
      hasVignette: true,
      overlayOpacity: 0.01,
    },
    {
      type: "text_section_hero",
      // headline: "Legal. Sauber. Eingetragen.",
      lead: "Ob Leistungssteigerung, Fahrwerk, Bremsen, Räder oder Sonderteile: Wir bereiten Ihren Porsche technisch und formal so vor, dass die Eintragung klappt – von der ersten Idee bis zur bestandenen Abnahme.",
      highlight: "End-to-end: Technik, Papiere, Prüftermin – wir kümmern uns.",
      spacing: "comfortable",
      size: "lg",
      variant: "primary",
      margin: false,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_6850_1_g9tvpo",
      headline: "TÜV-Eintragungen bei WTM",
      rightContent: (
        <SplitScreenContent
          headline="Wir machen Ihre Umbauten legal"
          intro="Sie haben Ihren Porsche umgebaut oder planen Modifikationen? Wir bereiten alles technisch und formal so vor, dass die TÜV-Eintragung klappt – von der ersten Idee bis zur bestandenen Abnahme."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Kompletter Service aus einer Hand",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Technische Prüfung, Unterlagen, Terminorganisation und Vorführung – wir übernehmen den gesamten Prozess. Sie bekommen Ihre Eintragung, ohne sich durch Paragraphen kämpfen zu müssen.",
            },
            {
              type: "heading",
              text: "Erfahrung mit Porsche-Umbauten",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Leistungssteigerungen, Hubraumerweiterungen, Fahrwerk, Bremsen, ITB/ECU-Setups – wir kennen die Eigenheiten jeder Porsche-Generation und wissen, worauf die Prüfer achten.",
            },
            {
              type: "heading",
              text: "Saubere Dokumentation garantiert",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Teilegutachten, ABE, Messprotokolle, Fotos, Stücklisten – unsere Dokumentation ist so gründlich, dass die Abnahme zur Formsache wird. Eintragen statt diskutieren.",
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Eintragung planen – wir managen alles",
                paragraph:
                  "Senden Sie uns kurz Ihre Umbauten oder Pläne. Wir klären Machbarkeit und Unterlagen und begleiten Ihr Fahrzeug bis zur erfolgreichen Abnahme.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen TÜV-Eintragungen - Legal und sauber",
      navbarHeight: 0,
    },

    // {
    //   type: "cta-with-modal",
    //   headline: "Unverbindlich TÜV-Machbarkeit prüfen",
    //   paragraph:
    //     "Sie planen Umbauten oder haben bereits modifiziert? Wir prüfen kostenlos die Eintragungsmöglichkeiten und erstellen Ihnen einen Fahrplan.",
    //   darkMode: true,
    //   spacing: "comfortable_top_tight_bottom",
    // },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_6882_bvftmt",
      headline: "Was wir eintragen",
      rightContent: (
        <SplitScreenContent
          headline="Alle gängigen Porsche-Umbauten"
          intro="Von Leistungssteigerungen über Fahrwerk bis zu Sonderanfertigungen – wir kennen die Regularien und sorgen für rechtssichere Eintragungen. Umbauten sind nur so gut wie ihre Unterlagen."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Motor & Leistung",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Hubraumerweiterungen, Einzeldrossel-Anlagen, Nockenwellen, ECU-Tuning – mit Prüfstand-Gutachten und allen erforderlichen Abgas- und Geräuschmessungen.",
            },
            {
              type: "heading",
              text: "Fahrwerk & Bremsen",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Federn, Dämpfer, Stabilisatoren, Bremsanlagen-Upgrades, Räder und Reifen – mit Freigängigkeitsprüfung und Lenkeinschlag-Kontrolle.",
            },
            {
              type: "heading",
              text: "Sonderanfertigungen",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Überrollbügel, Clubsport-Ausstattung, Karosserie- und Aero-Teile – mit technischen Zeichnungen, Material- und Festigkeitsangaben.",
            },
            {
              type: "heading",
              text: "HU & H-Kennzeichen",
              level: 3,
            },
            {
              type: "paragraph",
              text: "HU-Vorbereitung, H-Gutachten für Oldtimer und Import-Fahrzeuge – wir bringen alles auf Stand, damit es keine Überraschungen gibt.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "So läuft Ihre Eintragung ab",
                items: [
                  "Check & Beratung: Machbarkeit und benötigte Nachweise klären",
                  "Technische Umsetzung oder Review vorhandener Umbauten",
                  "Komplettes Unterlagenpaket: Gutachten, Fotos, Messprotokolle",
                  "Terminorganisation und Vorführung bei der Prüfstelle",
                  "Erfolgreiche Abnahme & Übergabe aller Dokumente",
                ],
                highlightedIndices: [0, 2, 4],
                icon: "check",
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen TÜV-Eintragungen - Alle Umbauten",
      navbarHeight: 0,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/L1013177_okl4hq",
      headline: "Für alle Porsche-Generationen",
      rightContent: (
        <SplitScreenContent
          headline="Von Classic bis GT – wir kennen alle"
          intro="Von luftgekühlten Klassikern bis zu modernen GT-Modellen – wir kennen die Eigenheiten und Toleranzen jeder Baureihe. Unsere Vorbereitung ist so gründlich, dass die Abnahme zur Formsache wird."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Luftgekühlte Klassiker",
              level: 3,
            },
            {
              type: "paragraph",
              text: "911 F- & G-Modell, 964, 993 – die klassischen Porsche mit ihren besonderen Regularien und Toleranzen. Wir wissen, was bei welcher Generation möglich ist.",
            },
            {
              type: "heading",
              text: "Moderne Porsche",
              level: 3,
            },
            {
              type: "paragraph",
              text: "996, 997, 991 (Carrera, Turbo, GT-Modelle), Boxster & Cayman – auch bei den wassergekühlten Modellen kennen wir alle Eintragungsmöglichkeiten.",
            },
            {
              type: "heading",
              text: "Sonder- & Track-Umbauten",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Backdates, Clubsport-Umbauten, Track-fokussierte Modifikationen – auch bei Sonderfahrzeugen finden wir den Weg zur legalen Eintragung.",
            },
            {
              type: "heading",
              text: "Unser Ziel: Eintragen statt diskutieren",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Technisch stimmig, rechtlich sauber – so bereiten wir Ihre Umbauten vor. Die Abnahme wird zur Formsache, weil alles perfekt dokumentiert ist.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "Warum TÜV mit WTM Sportwagen?",
                items: [
                  "Spezialisiert auf modifizierte Porsche aller Generationen",
                  "Kompletter Service: Technik, Unterlagen, Termin & Vorführung",
                  "Erfahrung mit allen gängigen Umbauten und Sonderanfertigungen",
                  "Saubere Dokumentation für problemlose Abnahmen",
                ],
                highlightedIndices: [0, 1],
                icon: "check",
              },
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Jetzt TÜV-Eintragung planen – wir managen alles",
                paragraph:
                  "Senden Sie uns kurz Ihre Umbauten oder Pläne. Wir klären Machbarkeit und Unterlagen und begleiten Ihr Fahrzeug bis zur erfolgreichen Abnahme.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen TÜV-Eintragungen - Alle Porsche-Modelle",
      navbarHeight: 0,
    },

    // {
    //   type: "relevant-posts",
    //   postSlugs: [
    //     "porsche-leistungssteigerung-luftgekuehlt",
    //     "sperrdifferential-nachruesten-964-993",
    //     "backdate-porsche-911-wtm",
    //     "gt3-wartungsintervalle",
    //   ],
    //   headline: "Werkstatt Journal: Umbauten, Legalität & Technik",
    //   darkMode: false,
    // },
  ],
};
